import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import { getHeadLineTextStyles, getHeadLineTextPosition } from 'common/entities/form/styleConfiguration/selectors';
import { DEFAULT_HEADLINE_POSITION } from 'common/entities/form/styleConfiguration/defaultValues';
import { LEFT, CENTER, RIGHT } from 'common/entities/form/styleConfiguration/constants';
import { headlineMediumFontSize, latoLineHeight, headLinePaddingBottom } from 'common/styles/typography';

import parseFontSize from '../../utils/parseFontSize';
import SanitizedHTML from '../SanitizedHTML';
import { withFormId } from '../FormIdContext';

const POSITION_TO_DISPLAY = {
    [LEFT]: LEFT,
    [CENTER]: CENTER,
    [RIGHT]: RIGHT,
};

const HeadlineContainer = styled.div.attrs({
    role: 'heading',
    'aria-level': '2',
})`
    font-family: ${(props) => props.font};
    font-size: ${(props) => parseFontSize(props.fontSize) || headlineMediumFontSize};
    color: ${(props) => props.color};
    padding-bottom: ${headLinePaddingBottom};
    line-height: ${latoLineHeight};
    text-align: ${(props) => POSITION_TO_DISPLAY[props.position]};
    word-break: break-word;
    white-space: pre-line;
`;

const BASE_COMPONENT_NAME = 'FormHeadline';

const FormHeadline = ({ formId, label }) => {
    const headlineTextStyles = useSelector((state) => getHeadLineTextStyles(state, formId));
    const headlineTextPosition =
        useSelector((state) => getHeadLineTextPosition(state, formId)) || DEFAULT_HEADLINE_POSITION;

    if (!label) return null;

    return (
        <HeadlineContainer
            data-qa={BASE_COMPONENT_NAME}
            font={get(headlineTextStyles, 'font.value')}
            fontSize={headlineTextStyles.fontSize}
            color={get(headlineTextStyles, 'color.value')}
            position={headlineTextPosition}
        >
            <SanitizedHTML innerHtml={label} />
        </HeadlineContainer>
    );
};

FormHeadline.propTypes = {
    label: PropTypes.string,
    formId: PropTypes.string.isRequired,
};

FormHeadline.defaultProps = {
    label: undefined,
};

export default withFormId(FormHeadline);
